<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div class="float-lg-left col-lg-8">
        <div id="accordionFilter" class="content">
          <div class="card">
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                 data-parent="#accordionFilter">
              <div class="card-body">
                <form>
                  <em-filter :entity="modelName" ref="emListFilter"
                             @doQuery="afterReloadRows"
                             @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div id="emMaMaintenanceScheduleResultTable" class="content">
          <div class="card my-1">
            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                 data-parent="#accordionResult">
              <div class="card-body">
                <em-table :entity="modelName" ref="emTable"
                          @doPagination="afterReloadRows"
                          @sortByColumn="afterReloadRows"
                          withCustomRowActions exportDisabled :inlineActionsDisabled="!prop_inline"
                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                  <template slot="customRowActions" slot-scope="customRowScope">
                    <b-button-group>
                      <em-button type="gotoChild"
                                 :class="toAclHolderClass(customRowScope.row.id)"
                                 customLabel="权限管理"
                                 showName
                                 @click="getRoleAclTreeNodes(customRowScope.row.id)">
                      </em-button>
                      <em-button type="gotoChild"
                                 :class="toUserHolderClass(customRowScope.row.id)"
                                 customLabel="用户管理"
                                 showName
                                 @click="getRoleUserTreeNodes(customRowScope.row.id)">
                      </em-button>
                    </b-button-group>
                  </template>
                </em-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="float-lg-right col-lg-4">
        <em-z-tree v-if="toAcls" ref="roleAclEmZTree" :treeNodes="roleAclTreeNodes" :chkboxType="chkboxType"
                   checkEnable>
        </em-z-tree>
        <em-z-tree v-if="toUsers" ref="roleUserEmZTree" :nodeAppender="appendIcon2UserNodes"
                   :treeNodes="roleUserTreeNodes" :chkboxType="chkboxType"
                   checkEnable>
        </em-z-tree>
        <div class="row">
          <div class="col-lg-12 align-self-end">
            <div class="float-lg-right">
              <em-button key="aclSave" v-if="toAcls" type="save" show-name
                         v-bind:class="'btn btn-primary'"
                         v-on:click="saveRoleAcls"></em-button>
              <em-button key="aclCancel" v-if="toAcls" type="cancel" show-name
                         v-bind:class="'btn btn-outline-secondary mr-1'"
                         v-on:click="getRoleAclTreeNodes(selectRoleId)"></em-button>
              <em-button key="userSave" v-if="toUsers" type="save" show-name
                         v-bind:class="'btn btn-primary'"
                         v-on:click="saveRoleUsers"></em-button>
              <em-button key="userCancel" v-if="toUsers" type="cancel" show-name
                         v-bind:class="'btn btn-outline-secondary mr-1'"
                         v-on:click="getRoleUserTreeNodes(selectRoleId)"></em-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"/>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-07-13 14:25:08

import {createHelpers} from "vuex-map-fields";
import emCommonListMixin from "@/mixin/em/common/list";
import emRouteHelperMixin from "@/mixin/em/helper/route";
import EmZTree from "@/components/em/EmZTree";
import commonViewsUtil from "@/utils/commonViewsUtil";

const modelName = "emAclRole";

// create a helper to generate getters and setters with namespace
const {mapFields} = createHelpers({
  getterType: modelName + '/getField',
  mutationType: modelName + '/updateField',
});
export default {
  name: "emAclRoleListView",
  mixins: [emCommonListMixin, emRouteHelperMixin],
  components: {EmZTree},
  props: {
    //是否启用行编辑
    prop_inline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toAcls: false,
      toUsers: false,
      roleAclTreeNodes: [],
      roleUserTreeNodes: [],
      selectRoleId: -1,
      userPrefix: "user_",
      deptPrefix: "dept_",
        chkboxType: {"Y": "p", "N": "p"} //仅子节点连带父节点
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    ...mapFields(['baseModuleUrl'])
  },
  methods: {
    getRoleAclTreeNodes(roleId) {
      //设置当前选中角色Id，保存时要用到
      this.selectRoleId = roleId
      let url = this.baseModuleUrl + "/emAclRoleAcl/roleAclTree" + "?roleId=" + roleId
      this.$store.dispatch("api/get", {url})
          .then(data => {
            this.roleAclTreeNodes = data
            this.showRoleAclTree()
          });
    },
    getRoleUserTreeNodes(roleId) {
      //设置当前选中角色Id，保存时要用到
      this.selectRoleId = roleId
      let url = this.baseModuleUrl + "/emAclRoleUser/roleUserTree" + "?roleId=" + roleId
      this.$store.dispatch("api/get", {url})
          .then(data => {
            this.roleUserTreeNodes = data
            this.showRoleUserTree()
          });
    },
    showRoleAclTree() {
      this.toAcls = true;
      this.toUsers = false;
    },
    showRoleUserTree() {
      this.toUsers = true;
      this.toAcls = false;
    },
    saveRoleAcls() {
      if (this.selectRoleId === -1) {
        commonViewsUtil.showAlert(this, "保存角色与权限点关系,请先在左侧选择角色")
        return;
      }
      var url = this.baseModuleUrl + "/emAclRoleAcl/roleAclTree"
      this.$store.dispatch("api/put", {
        url,
        entity: {
          roleId: this.selectRoleId,
          aclIds: this.getAclIds(this.$refs['roleAclEmZTree'].getCheckedNodes())
        }
      }).then(response => commonViewsUtil.showSuccess(this, "保存角色与权限点关系,操作成功"))
    },
    saveRoleUsers() {
      if (this.selectRoleId === -1) {
        commonViewsUtil.showWarning(this, "保存角色与用户关系,请先在左侧选择角色")
        return;
      }
      var url = this.baseModuleUrl + "/emAclRoleUser/roleUserTree"
      this.$store.dispatch("api/put", {
        url,
        entity: {
          roleId: this.selectRoleId,
          userIds: this.getUserIds(this.$refs['roleUserEmZTree'].getCheckedNodes())
        }
      }).then(response => commonViewsUtil.showSuccess(this, "保存角色与用户关系,操作成功"))
    },
    getAclIds(aclNodes) {
      var v = "";
      for (var i = 0; i < aclNodes.length; i++) {
        // if(aclNodes[i].id.startsWith(aclPrefix)) {
        v += "," + aclNodes[i].id;
        // }
      }
      return v.length > 0 ? v.substring(1) : v;
    },
    getUserIds(userNodes) {
      var v = "";
      for (var i = 0; i < userNodes.length; i++) {
        if (userNodes[i].id.startsWith(this.userPrefix)) {
          v += "," + userNodes[i].userId;
        }
      }
      return v.length > 0 ? v.substring(1) : v;
    },
    appendIcon2UserNodes(roleUserTreeNode) {
      let userPrefix = "user_"
      let deptPrefix = "dept_"
      if (roleUserTreeNode.id.startsWith(userPrefix)) {
        return Object.assign({iconSkin: "iconUser"}, roleUserTreeNode)
      } else if (roleUserTreeNode.id.startsWith(deptPrefix)) {
        if (!roleUserTreeNode.isParent)
          return Object.assign({iconSkin: "iconBuilding"}, roleUserTreeNode)
        else
          return Object.assign({iconSkin: "pIconBuilding"}, roleUserTreeNode)
      }
    },
    toAclHolderClass(roleId) {
      if (this.toAcls && this.selectRoleId && this.selectRoleId === roleId) {
        return "btn btn-success btn-sm";
      } else {
        return "btn btn-outline-primary btn-sm"
      }
    },
    toUserHolderClass(roleId) {
      if (this.toUsers && this.selectRoleId && this.selectRoleId === roleId) {
        return "btn btn-success btn-sm";
      } else {
        return "btn btn-outline-primary btn-sm"
      }
    },
    afterReloadRows() {
      //重新执行了查询，就初始化右侧两棵树相关数据
      this.toAcls = false
      this.toUsers = false
      this.roleAclTreeNodes = []
      this.roleUserTreeNodes = []
      this.selectRoleId = -1
    }
  }
}
;
</script>
